import p1 from '@/assets/img/gallery/portfolio-01/portfolio-01.jpg'
import p2 from '@/assets/img/gallery/portfolio-01/portfolio-02.jpg'
import p3 from '@/assets/img/gallery/portfolio-01/portfolio-03.jpg'

import pp1 from '@/assets/img/gallery/portfolio-02/portfolio-01.jpg'
import pp2 from '@/assets/img/gallery/portfolio-02/portfolio-02.jpg'
import pp3 from '@/assets/img/gallery/portfolio-02/portfolio-03.jpg'
import pp4 from '@/assets/img/gallery/portfolio-02/portfolio-04.jpg'
import pp5 from '@/assets/img/gallery/portfolio-02/portfolio-05.jpg'
import pp6 from '@/assets/img/gallery/portfolio-02/portfolio-06.jpg'

export const portfolioOne = [
    {
        id:1,
        image:p1,
        tag:'Classic Chair',
        name:'Classic Vase & Chair'
    },
    {
        id:2,
        image:p2,
        tag:'Art Design',
        name:'Classic Vase & Chair'
    },
    {
        id:3,
        image:p3,
        tag:'Design',
        name:'Classic Vase & Chair'
    },
    {
        id:4,
        image:p1,
        tag:'Vase',
        name:'Classic Vase & Chair'
    },
    {
        id:5,
        image:p2,
        tag:'Art',
        name:'Classic Vase & Chair'
    },
]

export const portfolioTwo = [
    {
        id:1,
        image:pp1,
        category: ["Sofa", "Interior"],
        tag:'Design',
        name:'Sofa & Chair'
    },
    {
        id:2,
        image:pp2,
        category:['Interior'],
        tag:'Art',
        name:'Full Interior Set'
    },
    {
        id:3,
        image:pp3,
        category:['Vase','Sofa'],
        tag:'Design',
        name:'Classic Vase & Chair'
    },
    {
        id:4,
        image:pp4,
        category:['Table'],
        tag:'Art Table',
        name:'Classic Vase & Chair'
    },
    {
        id:5,
        image:pp5,
        category:['Design'],
        tag:'Vase',
        name:'Art Design'
    },
    {
        id:6,
        image:pp6,
        category:["Interior", "Vase"],
        tag:'Full Interior',
        name:'Sofa & Chair'
    },
]